<!-- 学习班 修改 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="200px" style="width:800px;" label-position="left">
          <el-form-item label="学习班类型名">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="是否属于下属单位上传使用">
            <el-radio-group v-model="form.isBelongSub">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
           <el-button style="margin-top: 12px;" type="primary" @click="publish">更新</el-button>
            <!-- <el-button>取消</el-button> -->
          </el-form-item>
      </el-form>
    </el-card>

  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import request from "@/api/request";
import { editInitApi, editSaveApi } from "@/api/module/studyclasstype/studyclasstype";

export default {
  name: "StudyClassTypeEdit",
  
  mixins: [BaseVue],
  
  data() {
    return {
      form: {
        title: '',
        isBelongSub: 0
      },
      loading: false,
      title: "",
      id: ""
    };
  },
  
  methods: {
    publish() {
      if (!this.form.title) {
        this.$message.error("学习班名称不能为空！");
        this.loading = false;
        return false;
      }
      this.loading = true;

      const data = {
        id: this.id,
        title: this.form.title,
        isBelongSub: this.form.isBelongSub
      };

      editSaveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功,稍后该标签页会关闭！",
            type: "success"
          });
          setTimeout(() => {
            window.close();
          }, 2000);
        }).finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    
    editInitApi(this.id)
      .then(response => {
        this.form.title = response.title;
        this.form.isBelongSub = response.isBelongSub;
      }).finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
</style>

